import {CONTENT_HEIGHT_PX, CONTENT_WIDTH_PX, FIRST_PAGE_HEADER_PX} from './rich-text-page';

const BOX = '☐';
const TICKED = '☑';

// Mirrors the printed page: same width, font and heading sizes, with a red line where each A4 page ends.
export const RICH_TEXT_CONTENT_STYLE = `
  html { background: #e9ecef; }
  body {
    background-color: #fff; width: ${CONTENT_WIDTH_PX}px; margin: 0 auto; padding: 0; box-sizing: border-box;
    min-height: ${CONTENT_HEIGHT_PX}px;
    font-family: 'Open Sans', 'Helvetica Neue', Arial, sans-serif; font-size: 14px; line-height: 1.528571429; color: #000;
    background-image: linear-gradient(to bottom, transparent ${CONTENT_HEIGHT_PX - 2}px, #e57373 ${CONTENT_HEIGHT_PX - 2}px, #e57373 ${CONTENT_HEIGHT_PX}px);
    background-size: 100% ${CONTENT_HEIGHT_PX}px; background-repeat: repeat-y; background-position: 0 -${FIRST_PAGE_HEADER_PX}px;
  }
  p { margin: 0 0 10.5px; }
  h3 { font-size: 28px; } h4 { font-size: 22px; } h5 { font-size: 18px; }
`;

function boxRangeAtCaret(editor: any): Range | null {
  const rng = editor.selection.getRng();
  const node = rng.startContainer;
  if (node.nodeType !== Node.TEXT_NODE) {
    return null;
  }
  const text: string = node.nodeValue || '';
  const candidates = rng.collapsed ? [rng.startOffset, rng.startOffset - 1] : [rng.startOffset];
  const index = candidates.find(i => text[i] === BOX || text[i] === TICKED);
  if (index === undefined) {
    return null;
  }
  const range = editor.dom.createRng();
  range.setStart(node, index);
  range.setEnd(node, index + 1);
  return range;
}

function toggleBoxAtCaret(editor: any): boolean {
  const range = boxRangeAtCaret(editor);
  if (!range) {
    return false;
  }
  const next = range.toString() === BOX ? TICKED : BOX;
  editor.selection.setRng(range);
  editor.insertContent(next);
  return true;
}

export function setupRichTextEditor(editor: any, options: { tickOnClick: boolean }) {
  editor.ui.registry.addButton('checkbox', {
    text: BOX, tooltip: 'Insert checkbox',
    onAction: () => editor.insertContent(BOX + '&nbsp;')
  });
  editor.ui.registry.addButton('checktoggle', {
    text: TICKED, tooltip: 'Tick / untick the checkbox at the cursor',
    onAction: () => toggleBoxAtCaret(editor)
  });
  if (options.tickOnClick) {
    editor.on('click', (event: MouseEvent) => {
      if (event.detail <= 1) {
        toggleBoxAtCaret(editor);
      }
    });
  }
}
